import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DebitForm from './debit-form/debitForm';
import { KEY } from 'web/components/utils/stripeKey';
import styles from './debit.module.scss';
const DebitCard = () => {
  const stripePromise = loadStripe(KEY);
  return (
    <div className={styles.userInputForm}>
      <div className={styles.body}>
        <Elements stripe={stripePromise}>
          <DebitForm />
        </Elements>
      </div>
    </div>
  );
};
export default DebitCard;
